export default "__VITE_ASSET__UN_9dYbc__ 584w";